import styled from "styled-components";

export const AnimationContainer = styled.div`
    width: 100%;
    height: 20%;
    position: fixed;
    bottom: 45%;
    display: block;

    > svg
        overflow: auto;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 70% !important;
        pointer-events: none;
`;


// WEBPACK FOOTER //
// ./src/Components/Spinner/SpinnerStyle.js